import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=469285fe&scoped=true"
import script from "./LanguagesList.vue?vue&type=script&lang=js"
export * from "./LanguagesList.vue?vue&type=script&lang=js"
import style0 from "./LanguagesList.vue?vue&type=style&index=0&id=469285fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469285fe",
  null
  
)

export default component.exports